export const LIST_CONFIGURATION_BASE_PATH = '/settings/orders/list-configuration';
export const LIST_CONFIGURATION_EDIT_PATH = `${LIST_CONFIGURATION_BASE_PATH}/edit`;

export const LIST_CONFIGURATION_TEMPLATE_NAME = 'ROUTING_LISTS_TEMPLATE_ID';
export const LIST_CONFIGURATION_TEMPLATE_ID = '9465105a-e8a1-470c-9817-142d33bc4fcd';

export const MODULE_NAMES = {
  SETTINGS: 'SETTINGS',
};

export const CONFIG_NAMES = {
  ROUTING_LIST_CONFIGURATION: 'ROUTING_LIST_CONFIGURATION',
};

export const ROUTING_LIST_TOKEN = {
  routing: [
    {
      token: 'routingList.name',
      previewValue: 'Routing Name',
    },
    {
      token: 'routingList.notes',
      previewValue: 'Routing notes',
    },
    {
      token: 'title',
      previewValue: 'ABA Journal',
    },
    {
      token: '#users',
      previewValue: '',
    },
    {
      token: 'lastName',
      previewValue: 'John',
    },
    {
      token: 'firstName',
      previewValue: 'Doe',
    },
    {
      token: 'routingAddress',
      previewValue: '123 Main street',
    },
    {
      token: '/users',
      previewValue: '',
    },
  ],
};
